import React from 'react';
import { Grid } from '@material-ui/core';
import { ErrorMessage } from '../common/ErrorMessage';
import ProgramSection, { type ProgramSectionProps } from './ProgramSection';
import type { ApiError } from '../../api/types';

interface ProgramSectionContainerProps extends ProgramSectionProps {
  apiError?: ApiError;
}

function ProgramSectionContainer(props: ProgramSectionContainerProps) {
  const {
    verifyOnClick = () => {},
    apiResponse = null,
    apiError = false,
    isEnrolled = false,
    userId,
    customerAccountId,
  } = props;

  return (
    <Grid container xs={12}>
      {apiError && <ErrorMessage />}
      {!apiError && apiResponse && (
        <ProgramSection
          customerAccountId={customerAccountId}
          userId={userId}
          apiResponse={apiResponse}
          isEnrolled={isEnrolled}
          verifyOnClick={verifyOnClick}
        />
      )}
    </Grid>
  );
}

export default ProgramSectionContainer;
